import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useStore } from "./store";
import Main from "./Main";
import Login from "./Login";

function App() {
  const { token } = useStore();

  const [ authorized, setAuthorized ] = useState(false);

  useEffect(() => {
    if (token) {
      fetch(process.env.REACT_APP_API + "/auth", {
        headers: {
          "authorization": token
        }
      }).then((res) => {
        if (res.status === 204) {
          setAuthorized(true);
        } else {
          setAuthorized(false);
          Swal.fire({
            title: "자동 로그인 실패",
            html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
            icon: "error",
            confirmButtonText: "확인"
          });
        }
      }).catch((err) => {
        console.error(err);
        setAuthorized(false);
        Swal.fire({
          title: "자동 로그인 실패",
          text: err.toString(),
          icon: "error",
          confirmButtonText: "확인"
        });
      });
    } else {
      setAuthorized(false);
    }
  }, [token]);

  return (<>
    {
      authorized ? <Main/> : <Login/>
    }
  </>);
}

export default App;
